var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TepmplateBlock',{attrs:{"modClass":""}},[_c('div',{staticClass:"row recovery-wrap"},[(_vm.page === 0)?_c('RecoveryForm',{on:{"go-next":_vm.onNextClick}}):_c('RecoveryAuth',{attrs:{"email":_vm.email},on:{"goback":function($event){_vm.page = 0}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }